<template>
  <LayoutViewer
    :class="{
      'direction-row': props.options.direction === 'row',
      'direction-column': props.options.direction === 'column',
      'justify-left': props.options.justify === 'flex-start',
      'justify-center': props.options.justify === 'center',
      'justify-right': props.options.justify === 'flex-end',
      'justify-stretch': props.options.justify === 'stretch',
      'align-left': props.options.align === 'flex-start',
      'align-center': props.options.align === 'center',
      'align-right': props.options.align === 'flex-end',
      'align-stretch': props.options.align === 'stretch',
    }"
    v-if="props.options?.layout"
    :layout="props.options.layout"
  />
</template>

<script setup lang="ts">
import LayoutViewer from "./LayoutViewer.vue";

const props = defineProps<{
  options: any;
}>();
</script>

<style scoped>
.direction-row {
  display: flex;
  flex-direction: row;
}
.justify-left {
  justify-content: flex-start;
}
.justify-right {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-stretch {
  justify-content: stretch;
  & > * {
    flex: 1 1 auto;
  }
}
.align-left {
  align-items: flex-start;
}
.align-right {
  align-items: flex-end;
}
.align-center {
  align-items: center;
}
.align-stretch {
  align-items: stretch;
  & > * {
    flex: 1 1 auto;
  }
}
</style>
